<template>
  <!-- CONTENT -->
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Background />

    <Header
      :showGoBack="true"
      :title="'Verify number'"
    />

    <main
      :class="'scrollable container'"
      :style="{marginTop: '20px', marginBottom: '20px'}"
    >
      <p
        :class="'t16'"
        :style="{marginBottom: '30px'}"
      >
        We have sent you an SMS with a code to number +17 <br />
        0123456789.
      </p>
      <Input
        :leftIcon="PhoneSvg"
        :placeholder="'Enter your phone number'"
        :containerStyle="{marginBottom: '14px'}"
      />
      <Button
        :title="'Confirm'"
        :onClick="() => $router.push(routes.CONFIRMATION_CODE)"
      />
    </main>
  </div>
</template>

<script setup>
// routes
import {routes} from '@/routes';

// components
import {Input} from '@/components';
import {Button} from '@/components';
import {Header} from '@/components';
import {Background} from '@/components';

// svg
import {PhoneSvg} from '@/assets/svg';

// others
import {useOpacity} from '@/hooks';
const opacity = useOpacity();
</script>
